import { NgModule } from '@angular/core';
import type { Route } from '@angular/router';
import { RouterModule } from '@angular/router';

import { ProductOrderComponent } from './product-order/product-order.component';
import { ProductOrderDefaultStep, ProductOrderStepUrl } from './product-order.types';
import { ProductOrder2024Guard } from '../../guards/product-order-2024.guard';
import { PlanPicker2024Component } from '../../shared/plan-picker/2024/plan-picker-2024.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: ProductOrderComponent,
    children: [
      {
        path: ProductOrderStepUrl.ProductPicker,
        component: PlanPicker2024Component,
        canActivate: [ProductOrder2024Guard],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ProductOrderDefaultStep,
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
})
export class ProductOrder2024RoutingModule {}
